import { Controller } from 'stimulus';
import porta from 'porta';
import nl from 'porta/src/i18n/nl';
import de from 'porta/src/i18n/de';
import toArray from '@/helpers/toArray';

const messages = document.documentElement.lang === 'nl'
  ? nl
  : de;

class FormValidationController extends Controller {
  connect() {
    porta({
      target: this.element,
      messages,
      onValidate: (formElement) => {
        this.disableSubmitButton(formElement);
      },
      onError: (formElement) => {
        this.enableSubmitButton(formElement);
      },
      onValid: (formElement) => {
        // Wait a few seconds before re-enabling the form. There
        // is time between the form being succesfully validated
        // and the request being completed. We don't want to allow
        // the user to perform form submissions during this time.
        setTimeout(() => {
          this.enableSubmitButton(formElement);
        }, 5000);

        return true;
      },
    });
  }

  disableSubmitButton(formElement) {
    this.toggleSubmitButtonState(formElement, false);
  }

  enableSubmitButton(formElement) {
    this.toggleSubmitButtonState(formElement, true);
  }

  // eslint-disable-next-line class-methods-use-this
  toggleSubmitButtonState(formElement, state) {
    toArray(formElement.querySelectorAll('[type="submit"]')).forEach((button) => {
      button[state ? 'removeAttribute' : 'setAttribute']('disabled', 'disabled');
    });
  }
}

export default FormValidationController;
